import { render, staticRenderFns } from "./LatestResPopup.vue?vue&type=template&id=e1da01d6&scoped=true&lang=pug"
import script from "./LatestResPopup.vue?vue&type=script&lang=js"
export * from "./LatestResPopup.vue?vue&type=script&lang=js"
import style0 from "./LatestResPopup.vue?vue&type=style&index=0&id=e1da01d6&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1da01d6",
  null
  
)

export default component.exports